import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createVNode(_component_router_link, {
      class: _normalizeClass(_ctx.b('logo')),
      to: "/landing"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", { innerHTML: _ctx.displayedLogo }, null, 8, _hoisted_1)
      ]),
      _: 1
    }, 8, ["class"]),
    _createElementVNode("h1", {
      class: _normalizeClass(_ctx.b('title'))
    }, [
      _createTextVNode(_toDisplayString(_ctx.$t("Объединяя международные рынки")) + " ", 1),
      _hoisted_2,
      _createTextVNode(" " + _toDisplayString(_ctx.$t("Расширяя возможности глобальных трейдеров")), 1)
    ], 2)
  ], 2))
}